import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { ViewerLayerTypedOpsService } from '../../../../engine/services/layer-services/viewer-layer-service/viewer-layer-typed-ops.service';
import { addPointToPolygon } from './../actions/layers.actions';

@Injectable()
export class AddPointToPolygonEffects {
  constructor(private viewerLayerTypedOps: ViewerLayerTypedOpsService, private actions: Actions) {}

  addPointToPolygon = createEffect(
    () => {
      return this.actions.pipe(
        ofType(addPointToPolygon),
        tap(({ id, point }) => {
          this.viewerLayerTypedOps.addPointToPolygon(id, point);
        }),
      );
    },
    { dispatch: false },
  );
}
